module.exports = __webpack_public_path__ + "unsupported-page-image-desktop-1eada182.jpg";